import useScreenshotDetection from '../utils/useScreenshotDetection'

/**
 * Composant invisible qui active la détection de captures d'écran
 * Ce composant n'affiche rien, il sert uniquement à activer le hook
 */
const ScreenshotDetector = () => {
  useScreenshotDetection()
  return null
}

export default ScreenshotDetector